var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_4351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2139 22.6276C35.3553 28.143 39.8808 32.5271 45.3255 32.4564C50.6995 32.3149 55.0129 28.0016 55.1543 22.6276C55.2957 17.1121 45.2548 0.000153375 45.2548 0.000153375C45.2548 0.000153375 35.2139 17.1121 35.2139 22.6276Z",
    fill: "url(#paint0_linear_111_4351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5271 39.5981V37.3354C32.5271 36.204 33.3756 35.3555 34.507 35.3555L56.003 35.3555C57.1344 35.3555 57.9829 36.204 57.9829 37.3354L57.9829 39.5981L32.5271 39.5981Z",
    fill: "url(#paint1_linear_111_4351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2554 90.5097C37.1237 82.378 32.5275 71.2764 32.5275 59.8213V39.5981H57.9833L58.054 59.7506C57.9833 71.2764 53.3871 82.378 45.2554 90.5097Z",
    fill: "url(#paint2_linear_111_4351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3052 27.5773C40.6588 30.335 43.2044 32.1735 45.9621 31.8199C48.1541 31.4664 49.8512 29.7693 50.2047 27.5773C50.2047 24.7489 45.255 15.5565 45.255 15.5565C45.255 15.5565 40.2345 24.8196 40.3052 27.5773Z",
    fill: "url(#paint3_linear_111_4351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9824 57.9827L59.1138 56.8513C65.1949 50.7702 68.589 42.5678 68.589 33.9411C68.589 32.9511 67.8112 32.1733 66.8919 32.244C66.3262 32.244 65.6899 32.5976 65.407 33.1633C63.7807 36.0624 61.1644 38.3958 58.0531 39.6686L57.9824 57.9827Z",
    fill: "url(#paint4_linear_111_4351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5272 57.9828L31.3959 56.8514C25.3148 50.7703 21.9206 42.5678 21.9206 33.9411C21.9206 32.9512 22.6985 32.1734 23.6177 32.2441C24.1834 32.2441 24.8198 32.5976 25.1026 33.1633C26.729 36.0625 29.3453 38.3959 32.4565 39.6687L32.5272 57.9828Z",
    fill: "url(#paint5_linear_111_4351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2549 90.5098C42.4264 87.6814 40.0223 84.4287 38.0424 80.8931C42.3557 77.7112 48.154 77.7112 52.4674 80.8931C50.4875 84.4287 48.0833 87.6814 45.2549 90.5098Z",
    fill: "url(#paint6_linear_111_4351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0123 62.2254C38.6692 64.5685 38.6692 68.3675 41.0123 70.7107C43.3555 73.0538 47.1544 73.0538 49.4976 70.7107C51.8407 68.3675 51.8407 64.5685 49.4976 62.2254C47.1544 59.8822 43.3555 59.8822 41.0123 62.2254Z",
    fill: "url(#paint7_linear_111_4351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3051 61.5183C43.0628 58.7606 47.4468 58.7606 50.2045 61.5183C52.9623 64.276 52.9623 68.66 50.2045 71.4178C47.4468 74.1755 43.0628 74.1755 40.3051 71.4178C37.5473 68.66 37.5473 64.276 40.3051 61.5183ZM48.7903 70.0036C50.7702 68.0237 50.7702 64.9124 48.7903 62.9325C46.8104 60.9526 43.6992 60.9526 41.7193 62.9325C39.7394 64.9124 39.7394 68.0237 41.7193 70.0036C43.6992 71.9835 46.8104 71.9835 48.7903 70.0036Z",
    fill: "url(#paint8_linear_111_4351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8408 31.1128C44.1943 30.7593 44.6893 30.5471 45.255 30.5471C46.3864 30.5471 47.2349 31.3956 47.2349 32.527V52.326C47.2349 53.4574 46.3864 54.3059 45.255 54.3059C44.1236 54.3059 43.2751 53.4574 43.2751 52.326V32.527C43.2751 31.9613 43.4872 31.4664 43.8408 31.1128Z",
    fill: "url(#paint9_linear_111_4351)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_111_4351",
    x1: 54.404,
    y1: 9.14941,
    x2: 36.0193,
    y2: 27.5342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9A254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4BB79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_111_4351",
    x1: 52.3692,
    y1: 30.9127,
    x2: 38.0701,
    y2: 45.2118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474F72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878C9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_111_4351",
    x1: 29.3632,
    y1: 42.8331,
    x2: 61.1476,
    y2: 74.6175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_111_4351",
    x1: 49.8512,
    y1: 20.1527,
    x2: 40.3052,
    y2: 29.6986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBCC88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE5C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_111_4351",
    x1: 71.0525,
    y1: 35.7202,
    x2: 53.3862,
    y2: 53.3865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA5466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4929C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_111_4351",
    x1: 19.4571,
    y1: 35.7202,
    x2: 37.1234,
    y2: 53.3866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA5466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4929C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_111_4351",
    x1: 41.0546,
    y1: 77.9091,
    x2: 49.4551,
    y2: 86.3096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA5466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4929C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_111_4351",
    x1: 49.4976,
    y1: 62.2254,
    x2: 41.0123,
    y2: 70.7107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DD5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3E1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_111_4351",
    x1: 40.3051,
    y1: 61.5183,
    x2: 50.2045,
    y2: 71.4178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CCDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_111_4351",
    x1: 38.891,
    y1: 36.0626,
    x2: 51.6189,
    y2: 48.7905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA5466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4929C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_4351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(90.5098 45.2549) rotate(135)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.33b33b494668e9420dc73b2c8fa91109.svg";
export { ForwardRef as ReactComponent };